/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-08-09 15:32:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-25 17:59:47
 * @FilePath: /code/mall-fe/src/comps/Layout.tsx
 * @Description: 商城首页布局容器
 *
 */
/* eslint-disable no-param-reassign */
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
import Body from 'comps/Body';
import FixedMenu from 'comps/FixedMenu';
import Head from 'comps/Head';
import { MediaQueryContext, SiteContext } from 'libs/contexts';
import { emptyStyles } from 'libs/utils';
import { useContext } from 'react';
import { cls } from 'reactutils';

type LayoutProps = {
  title?: string;
  keywords: string;
  description: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  styles?: string | JSX.Element;
  className?: string;
  bgColor?: string;
  showFixedMenu?: boolean;
  HomeAdvert?: boolean;
  supplierSysNo?: string;
};

export default function Layout({
  title,
  keywords,
  description,
  header,
  footer,
  children,
  className,
  styles = emptyStyles,
  bgColor,
  showFixedMenu = true,
  supplierSysNo = null,
}: LayoutProps) {
  const site = useContext(SiteContext);
  const { isMobile } = useContext(MediaQueryContext);
  // 租户名称
  const tenantName = site?.basic?.tenantName ?? '';

  title = title ? title : tenantName;
  keywords = `${tenantName},${keywords}`;

  return (
    <ConfigProvider locale={zhCN} autoInsertSpaceInButton={false}>
      <div className={cls('layout', className)}>
        <Head title={title} keywords={keywords} description={description} />

        {header}
        <Body bgColor={bgColor}>{children}</Body>
        {footer}
        {!isMobile && showFixedMenu && <FixedMenu supplierSysNo={supplierSysNo} />}
      </div>

      <style jsx>{`
        .layout {
          display: table;
          table-layout: fixed;
          min-width: ${!isMobile ? '1200px' : '100%'};
          min-height: 100vh;
          width: 100%;
          height: auto;
          background-color: #fff;
        }
        @-moz-document url-prefix() {
          .layout {
            height: 0;
          }
        }
      `}</style>
      <style jsx>{styles}</style>
    </ConfigProvider>
  );
}
